import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";

const reviewApi = {
  getReviews: (params) => {
    const url = "review";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getReview: (id) => {
    const url = "review";
    return axiosClient.get(url + "/" + id);
  },

  createReview: (params) => {
    const url = "review";
    // const payload = CheckNullParams(params);
    return axiosClient.post(url, params);
  },
  updateReview: (id, payload) => {
    const url = "review/";
    return axiosClient.patch(url + id, payload);
  },
  deleteReview: (params) => {
    const url = "review";
    return axiosClient.delete(url, { params });
  },

  changeStatus: (params) => {
    const url = "review/change-status";
    return axiosClient.patch(url, params);
  },
};

export default reviewApi;
